import React from 'react';
import PropTypes from 'prop-types';
import { addUserMessage } from 'react-chat-widget-t';
import {
  Button,
} from '@material-ui/core';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { blue } from '@material-ui/core/colors';
import { sendTextMessage } from '../Webwidget/actions';

const useStyles = makeStyles(() => ({
  button: {
    color: 'white',
    fontWeight: 'bold',
    backgroundColor: blue[400],
    '&:hover': {
      backgroundColor: blue[300],
    },
    marginBottom: '5px',
  },
}));

function appendProtocolIfNeed(buttonUrl) {
  if (!buttonUrl.startsWith('http')) {
    return `https://${buttonUrl}`;
  }
  return buttonUrl;
}

function CardButton(props) {
  const classes = useStyles();
  const { title, url } = props;
  return (
    <Button
      variant="contained"
      size="small"
      className={classes.button}
      key={title}
      fullWidth
      onClick={() => {
        if (url) {
          window.open(appendProtocolIfNeed(url), '_blank');
        } else {
          props.sendTextMessage(title);
          addUserMessage(title);
        }
      }}
    >
      <span style={{ whiteSpace: 'normal', width: '100%' }}>
        {title}
      </span>
    </Button>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ sendTextMessage }, dispatch);
}

const withConnect = connect(
  null,
  mapDispatchToProps,
);

CardButton.propTypes = {
  sendTextMessage: PropTypes.func.isRequired,
  title: PropTypes.string,
  url: PropTypes.string,
};

export default compose(
  withConnect,
)(CardButton);
